module.exports = __webpack_public_path__ + "img/base_activites_visite_ferme.c20093d6.svg";